"use client"

import { css } from "@emotion/css"
import React from "react"

import InnerBlocks from "@/components/course-material/ContentRenderer/util/InnerBlocks"
import ParsedText from "@/components/course-material/ParsedText"
import Centered from "@/shared-module/common/components/Centering/Centered"
import { primaryFont } from "@/shared-module/common/styles"
import withErrorBoundary from "@/shared-module/common/utils/withErrorBoundary"
import { sanitizeCourseMaterialHtml } from "@/utils/course-material/sanitizeCourseMaterialHtml"

import type { BlockRendererProps } from ".."

interface TerminnologyBlockAttributes {
  title: string
  primaryColor: string
  content: string
  blockName: string
}

const TerminologyBlock: React.FC<
  React.PropsWithChildren<BlockRendererProps<TerminnologyBlockAttributes>>
> = (props) => {
  const title = props.data.attributes.title
  const hasTitle = Boolean(title && title.trim() !== "")
  return (
    <div
      className={css`
        width: 100%;
        padding: 2rem 2rem 4rem 2rem;
        border-left: 8px solid ${props.data.attributes.primaryColor};
        box-shadow: rgba(25, 35, 51, 0.06) 0px 2px 12px 0px;

        p {
          margin: 0 !important;
          font-size: 18px;
          line-height: 160%;
        }

        div {
          margin-bottom: 0 !important;
        }
        h2 {
          margin-top: 1.5rem;
          font-weight: 600;
          font-family: ${primaryFont};
          margin-bottom: 0.8rem;
          font-weight: 600;
          font-size: 30px;
          color: #1a2333;
        }
      `}
    >
      <span
        className={css`
          font-size: 1rem;
          color: ${props.data.attributes.primaryColor};
          line-height: 100%;
          font-weight: 400;
        `}
        dangerouslySetInnerHTML={{
          __html: sanitizeCourseMaterialHtml(props.data.attributes.blockName),
        }}
      />
      {hasTitle && <ParsedText text={title} tag="h2" useWrapperElement={true} />}
      <Centered variant="narrow">
        <InnerBlocks parentBlockProps={props} dontAllowInnerBlocksToBeWiderThanParentBlock />
      </Centered>
    </div>
  )
}

export default withErrorBoundary(TerminologyBlock)
